// Filter sessions to those linked to the selected course.
// Sessions with no course linkage (legacy/global) are always included.
export const filterSessionsByCourse = (sessions, courseId) => {
  if (!courseId || !Array.isArray(sessions)) return sessions || [];
  return sessions.filter(s =>
    s.course_id === courseId ||
    (Array.isArray(s.course_ids) && s.course_ids.includes(courseId)) ||
    (!s.course_id && (!s.course_ids || s.course_ids.length === 0))
  );
};

export default filterSessionsByCourse;
